// * ACTIONS
export const FETCHTESTING = 'prueba/FETCHTESTING';
export const FETCHTESTING2 = 'prueba/FETCHTESTING2';

// * MUTATION
export const MUTATETESTING = 'prueba/MUTATETESTING';

// * GETTERS
export const GETTESTING = 'prueba/MUTATETESTING';
